import "./team-member.scss";